import styled from "styled-components";
import { Control, FieldValues } from "react-hook-form";
import SelectField from "components/UI/SelectField";
import { rangeOptionsStandard } from "common/search/search_common";
import { useState } from "react";
import DatePickerField from "components/UI/DatePickerField";
import { SEARCH_RANGES } from "constant/search";

type DatumSearchProps = {
  control: Control<FieldValues, any>;
  fieldName: string;
  defaultValue: any;
  fieldRangeTypeName: string;
  defaultRangeTypeValue: string;
  fieldSecondRangeName: string;
  defaultSecondRangeValue: any;
};

const DatumSearch = ({
  control,
  fieldName,
  defaultValue,
  fieldRangeTypeName,
  defaultRangeTypeValue,
  fieldSecondRangeName,
  defaultSecondRangeValue,
}: DatumSearchProps) => {
  const [showSecondRange, setShowSecondRange] = useState<boolean>(false);

  const rangeOptions = rangeOptionsStandard();
  return (
    <Div>
      {showSecondRange && (
        <DivDatumSecondRange>
          <DatePickerField
            control={control}
            name={fieldSecondRangeName}
            label="datum"
            defaultValue={defaultSecondRangeValue}
          />
        </DivDatumSecondRange>
      )}
      <SelectField
        label=""
        name={fieldRangeTypeName}
        control={control as unknown as Control<FieldValues, any>}
        options={rangeOptions}
        defaultValue={defaultRangeTypeValue}
        onSelect={(val: any) => {
          if (val === SEARCH_RANGES.START_END.value) {
            setShowSecondRange(true);
          } else {
            setShowSecondRange(false);
          }
        }}
      />
      <DivDatum>
        <DatePickerField
          control={control}
          name={fieldName}
          label="datum"
          defaultValue={defaultValue}
        />
      </DivDatum>
    </Div>
  );
};

const Div = styled.div`
  margin-left: 0rem;
  display: flex;
  input {
    width: 5rem;
  }
`;

const DivDatum = styled.div`
  margin-left: 1rem;
  input {
    width: 5rem;
  }
`;

const DivDatumSecondRange = styled.div`
  margin-left: 0rem;
  margin-right: 1rem;
  input {
    width: 5rem;
  }
`;

export default DatumSearch;
